'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productDetailContentComponent = undefined;

var _marked = require('marked');

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = require('./../../../common/core/markedRenderer');

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var productDetailContentComponent = exports.productDetailContentComponent = {
    template: require('./product-detail-content.html'),
    bindings: {
        product: '=',
        onChange: '&',
        addToCart: '&',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "cartService", "productService", "Enums", "authService", function controller($scope, cartService, productService, Enums, authService) {
        'ngInject';

        var vm = this;
        vm.onChangeQuantity = onChangeQuantity;
        vm.addToCartEnabled = true;
        vm.$onInit = init;
        vm.checkedStock = false;
        vm.stock = null;
        vm.context = Enums.productContexts['PRODUCTDETAIL'];
        vm.getGrossProfit = getGrossProfit;
        vm.getProductDiscounts = getProductDiscounts;
        vm.addProductToCart = addProductToCart;
        vm.isFebelcoCustomer = isFebelcoCustomer;
        vm.productDiscounts = {};
        $scope.forms = {};

        /* On it prepare the marked data */
        function init() {
            if (vm.product.mediPimData) {
                vm.product.mediPimData = Object.assign(vm.product.mediPimData, {
                    description: (0, _marked2.default)(vm.product.mediPimData.description || '')
                });
            }
            vm.getProductDiscounts();
        }

        /* get the product discounts */
        function getProductDiscounts() {
            vm.productDiscounts = vm.product.productDiscounts;

            // productService.getProductDiscounts(vm.product.id).then(x => {
            //     vm.productDiscounts = productService.formatProductDiscount(x);
            // });
        }

        /* On change: update the product totals */
        function onChangeQuantity() {
            // vm.product.updateTotals();
            vm.onChange();
        }

        /* Calculate the gross profit */
        function getGrossProfit() {
            return productService.calculateGrossProfitWithoutDiscount(vm.product);
        }

        // function getGrossProfitAmount(){
        //     return productService.calculateGrossProfitAmount(vm.product);
        // }

        function addProductToCart() {
            $scope.forms.productOverviewForm.$setPristine();
            vm.addToCart();
        }

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/product/components/product-detail-content.js
// module id = 969
// module chunks = 0